<script setup lang="ts"></script>

<template>
  <h2 class="inset-x-6 top-6 mb-2 text-lg font-bold leading-6">
    <slot></slot>
  </h2>
</template>
